var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#D8EBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8395 12.9996L23.0336 11.1937L24.2911 9.93624C24.5055 9.72182 24.5055 9.37524 24.2911 9.16082C24.0767 8.94639 23.7301 8.94639 23.5156 9.16082L15.8579 16.8186C15.9988 16.9343 16.1343 17.0571 16.2648 17.1871C16.3953 17.3176 16.5176 17.453 16.6333 17.594L20.0646 14.1627L21.8705 15.9685C21.9774 16.0755 22.1178 16.1292 22.2582 16.1292C22.3986 16.1292 22.539 16.0755 22.6459 15.9685L24.8395 13.775C25.0539 13.5606 25.0539 13.214 24.8395 12.9996Z",
    fill: "#3397F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4894 17.9626C14.6608 17.134 13.559 16.6777 12.3871 16.6777C11.2152 16.6777 10.1135 17.134 9.28488 17.9626C8.45626 18.7912 8 19.893 8 21.0649C8 22.2368 8.45626 23.3385 9.28488 24.1671C10.1135 24.9957 11.2152 25.452 12.3871 25.452C13.559 25.452 14.6608 24.9957 15.4894 24.1671C16.318 23.3385 16.7743 22.2368 16.7743 21.0649C16.7743 19.893 16.318 18.7912 15.4894 17.9626Z",
    fill: "#3397F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRooms);
export default __webpack_public_path__ + "static/media/Total_Rooms.ffca7c618a05251223d4db693b7ba7bc.svg";
export { ForwardRef as ReactComponent };